import axios from 'axios';
import {useState, useEffect, useCallback} from 'react';
import Box from '@mui/material/Box';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import Loading from '../components/common/Loading';
import Error from '../components/common/Error';

import CustomerReelsList from '../components/rts/CustomerReels/CustomerReelsList';
import CustomerReelsHeader from '../components/rts/CustomerReels/CustomerReelsHeader';
import CustomerReelsFilter from '../components/rts/CustomerReels/CustomerReelsFilter';

import { useSessionContext } from '../contexts/SessionContext';

export default function CustomerReelsPage( props ){
    //console.debug("RTS Break CustomerReelsPage");

    const {curFilter, sessionCustomer, userAuthToken, apiRoot} = useSessionContext();

    const theme = useTheme();
    const smallForm = useMediaQuery(theme.breakpoints.down("sm"));

    const [hasError, setHasError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const [filter, setFilter] = useState();
    const [data, setData] = useState([]);
    
    const fetchData = useCallback((pFilter) => {
        setIsLoading(true);
        let apiURL = apiRoot + "/Reels/GetReelsSummary";
        axios
        .post(
            apiURL,
            pFilter,
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            if (response.data) {
                setIsLoading(false);
                setData(response.data);
            }
            else{
                setIsLoading(false);
            }
        })
        .catch(error => {
            setHasError(true);
            console.log("RTS Data Error", error);
        });
    },[apiRoot, userAuthToken.token]);

    
    useEffect(() => {
        props.setIsModalFx(false);
        if(curFilter != null && curFilter.key === 'CustomerReelsPage'){
            setFilter(curFilter.filter);
        }
        else{
            setFilter({reelType:null, status:1});
        }
    }, [props, curFilter]); 


    useEffect(() => {
        props.setIsModalFx(false);
        if(curFilter != null && curFilter.key === 'CustomerReelsPage'){
            setFilter(curFilter.filter);
            fetchData(curFilter.filter);
        }
        else{
            setFilter({customer:sessionCustomer.customer, reelType:null, status:1});
            fetchData({customer:sessionCustomer.customer, reelType:null, status:1})
        }
    }, [props, curFilter, fetchData, sessionCustomer.customer]); 


    const setTableHeight = () => {
        let retValue;

        if(smallForm){
            retValue = 'auto';
        }
        else{
            retValue = '75vh';
        }
        return retValue;
    };    


    if(hasError){
        return(
            <Error />
        );
    }


    if(isLoading){
        return(
            <Loading />
        );
    }


    return(
        <>
        <Box>
            <CustomerReelsHeader />
            <CustomerReelsFilter filter={filter} setFilterFx={setFilter}/>
            <Box sx={{mt:2, height:setTableHeight(), minHeight:'500px'}}>           
                <CustomerReelsList data={data} />
            </Box>
        </Box>
        </>
    );
}
